import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent
} from "@softline/dynamic";
import { OrteListView } from "./list-view/orte.list-view";

export const orteFieldOk: FieldOkConfig = {
  name: 'orte',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{postleitzahl}} {{ort}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: OrteListView,
    }
  }
  ]
};
export const orteMultiselectFieldOk: FieldOkConfig = {
  name: 'orte',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{postleitzahl}} {{ort}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: FieldOkMultiselectListViewComponent,
    title: 'Auswahl',
    config: {
      component: OrteListView,
    }
  }
  ]
};

export const orteQueryFieldOk: FieldOkConfig = {
  name: 'orte',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{postleitzahl}} {{ort}}',
  autoQuery: true,
  views: [{
    name: 'list',
    component: QueryFieldOkListViewComponent,
    title: 'Auswahl',
    config: {
      component: OrteListView,
    }
  }
  ]
};
